import type { MissionPointDraft, MissionPointItem } from './missionModels';

type MissionPointLike = {
    actionType?: string | null;
    patternPointId?: number | null;
    params?: Record<string, any> | null;
    patternPoint?: {
        pointIndex?: number | null;
    } | null;
};

const ACTION_PREFIX_MAP: Record<string, string> = {
    start: 'S',
    end: 'E',
    move: 'M',
    measure: 'R',
    wait: 'W',
    dock: 'D',
    custom: 'C',
    home: 'H',
    pass_through: 'T',
};

const getPatternIndexBase = (points: MissionPointLike[]): 0 | 1 => {
    const explicitIndices = points
        .map((point) => point.patternPoint?.pointIndex ?? point.params?.patternPointIndex)
        .map((value) => Number(value))
        .filter((value) => Number.isFinite(value));

    return explicitIndices.includes(0) ? 0 : 1;
};

const getPatternOrdinal = (
    point: MissionPointLike,
    points: MissionPointLike[],
    index: number
): number => {
    const indexBase = getPatternIndexBase(points);
    const explicitIndex = point.patternPoint?.pointIndex ?? point.params?.patternPointIndex;
    if (Number.isFinite(Number(explicitIndex))) {
        const numericIndex = Number(explicitIndex);
        return indexBase === 0 ? numericIndex + 1 : numericIndex;
    }

    return points
        .slice(0, index + 1)
        .filter((candidate) => Boolean(candidate.patternPointId))
        .length;
};

const getActionPrefix = (point: MissionPointLike): string => {
    const actionType = String(point.actionType || 'custom').trim().toLowerCase();
    return ACTION_PREFIX_MAP[actionType] || 'C';
};

export const getMissionPointMarkerLabel = (
    points: Array<MissionPointDraft | MissionPointItem>,
    point: MissionPointDraft | MissionPointItem,
    index: number
): string => {
    if (point.patternPointId) {
        return `P${getPatternOrdinal(point, points, index)}`;
    }

    const prefix = getActionPrefix(point);
    const occurrence = points
        .slice(0, index + 1)
        .filter((candidate) => !candidate.patternPointId && getActionPrefix(candidate) === prefix)
        .length;

    return occurrence > 1 ? `${prefix}${occurrence}` : prefix;
};
